import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpParams } from '@angular/common/http';
import { LOCALE_ID, Inject } from '@angular/core';
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { NgModule } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
@Component({
    selector: 'app-sub-and-reg',
    templateUrl: './sub-and-reg.component.html',
    styleUrls: ['./sub-and-reg.component.scss']
})
export class SubAndRegComponent implements OnInit {


    constructor(@Inject(LOCALE_ID) protected localeId: string, private route: ActivatedRoute, private http: HttpClient, private router: Router, ) {
        this.route.queryParamMap.subscribe(params => {
            console.log('1st Load Params')
            console.log(params)
            this.paramObj = { ...params.keys, ...params };
            this.operatorIDBase = this.paramObj.params.operatorID;
        });
        if (this.operatorIDBase != null) {
            this.site();
        }
        else {
            this.disclaimerLoaded = false;
            this.userStatus = true;
            this.checkParams();
          
        }
    }
    profileName = '';
    mondiaStatus = '';
    siteIDCurrent = '';
    mondiacustID = '';
    usernameLogin = '';
    channelID = '';
    customerId = '';
    siteID = '';
    siteIDCall = environment.siteID;
    siteInfo: any = [];
    sitebillingAgent: any;
    siteRenew: any;
    channelbillingAgent: any;
    currencySign: any;
    passLogin = '';
    subData: any = [];
    subID = '';
    mondiaOperatorID = '';
    mondiaOperatorText = ''
    operatorID: any;
    redirectURL = '';
    failedSub: boolean = false;
    doubleOpt: boolean = true;
    userStatus: boolean = false;
    tempPass = '';
    operatorIDBase: '';
    showPass: boolean = false;
    disclaimerLoaded = false;
    loaded: boolean = false;
    username = '';
    isTrue: boolean = false;
    orderObj: any = [];
    paramObj: any = [];
    hideUsername: boolean = true;
    productId: any;
    disclaimer: any;
    disclaimerHTML: any;
    preferredCountries = [
        { "country": "South Africa", "code": 'za', "dialcode": "+27" },
        { "country": "Nigeria", "code": 'ng', "dialcode": "+97" },
        { "country": "Tunisia", "code": 'tu', "dialcode": "+22" },
        { "country": "Egypt", "code": 'eg', "dialcode": "+20" }
    ];
    public site() {
        const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
        let body = new HttpParams();
        this.route.queryParamMap.subscribe(params => {
            this.paramObj = { ...params.keys, ...params };
            this.operatorIDBase = this.paramObj.params.operatorID;
            if(this.operatorIDBase) {
            localStorage.setItem('operatorID', (this.operatorIDBase));
            }
        });
        this.http.get('https://staging.videyo.tv/manage/getSite?siteID='+this.siteIDCall+'&operatorID='+this.operatorIDBase, {
          headers: myheader
        })
          .subscribe(
            data => {
              this.siteInfo = data;
              console.log('site info');
              console.log(this.siteInfo);
              this.siteIDCurrent = data['id'];
              this.productId = data['productId'];
              this.getDisclaimer();
              this.sitebillingAgent = this.siteInfo.billingAgent.name;
              this.siteRenew = this.siteInfo.billingFrequency.name;
              this.currencySign = this.siteInfo.currency.sign;
              if (window.location.href.indexOf("/ar/") > -1) { 
                this.currencySign = this.siteInfo.currency.alternativeSigns.ar;
              }
              else { 
                this.currencySign = this.siteInfo.currency.sign;
              }
            },
            error => {
            }
          );
      }
      goToTermConditions() { 
          console.log('clicked clicked clicked')
        if (window.location.pathname.indexOf('\/en\/') > -1) {
            this.router.navigate(['/terms-and-conditions/' + this.productId + '/m/' +this.siteIDCurrent+'/'+this.operatorIDBase]);
        }
        else if (window.location.pathname.indexOf('\/ar\/') > -1) {
            this.router.navigate(['/terms-and-conditions/' + this.productId + '/m/' +this.siteIDCurrent+'/'+this.operatorIDBase]);
        }
        else if (window.location.pathname.indexOf('\/fr\/') > -1) {
            this.router.navigate(['/terms-and-conditions/' + this.productId + '/m/' +this.siteIDCurrent+'/'+this.operatorIDBase]);
        }
        else {
            this.router.navigate(['/terms-and-conditions/' + this.productId + '/m/' +this.siteIDCurrent+'/'+this.operatorIDBase]);
        }
        }
    public checkParams() {
        this.doubleOpt = false;
        this.route.queryParamMap.subscribe(params => {
            this.orderObj = { ...params.keys, ...params };
            this.channelID = this.orderObj.params.channelID;
            this.mondiaOperatorID = localStorage.getItem('operatorID');
            this.mondiaOperatorText = this.orderObj.params.operator;

            if (!this.siteID && this.orderObj.params.siteID) {
                this.siteID = this.orderObj.params.siteID;
                localStorage.setItem('siteID', (this.siteID));
            }
            else if (!this.siteID && !this.orderObj.params.siteID) { 
                this.siteID = localStorage.getItem('siteID');
                if (!this.siteID) {
                    this.siteID = '9';
                }
            }
                

            console.log('check params');
            this.customerId = this.orderObj.params.customerId;
            if (this.mondiaOperatorID) {
                localStorage.setItem('operatorID', (this.mondiaOperatorID));
            }
            console.log(params);
            var status = this.orderObj.params.status;
            console.log(status);
            if (status != 'ERROR' && !this.customerId && this.mondiaOperatorID && (this.siteID || this.channelID)) {
                console.log('Mondia Redirect')
                this.redirectToMondia();
            }
            else if (this.customerId) {
                console.log('Create & Sub');
                this.createandsub();
            }
            else {
                if (window.location.pathname.indexOf('\/en\/') > -1) {
                    window.location.href = '/en/register'

                }
                else if (window.location.pathname.indexOf('\/fr\/') > -1) {
                    window.location.href = '/fr/register'

                }
                else if (window.location.pathname.indexOf('\/ar\/') > -1) {
                    window.location.href = '/ar/register'

                }
                else  {
                    window.location.href = '/register'

                }
            }
        })
    }
   
    redirectToMondia() {
        if (window.location.pathname.indexOf('\/en\/') > -1) {
            window.location.href = 'http://login.mondiamediamena.com/billinggw-lcm/billing?method=getcustomer&merchantId=243&redirect='+environment['link']+'en%2Fsubscribe-and-register&operatorId=' + this.mondiaOperatorID
            console.log('EN/REG&SUB');
        }
        else if (window.location.pathname.indexOf('\/fr\/') > -1) {
            window.location.href = 'http://login.mondiamediamena.com/billinggw-lcm/billing?method=getcustomer&merchantId=243&redirect='+environment['link']+'fr%2Fsubscribe-and-register&operatorId=' +this.mondiaOperatorID
            console.log('FR/REG&SUB');
        }
        else if (window.location.pathname.indexOf('\/ar\/') > -1) {
            window.location.href = 'http://login.mondiamediamena.com/billinggw-lcm/billing?method=getcustomer&merchantId=243&redirect='+environment['link']+'ar%2Fsubscribe-and-register&operatorId=' +this.mondiaOperatorID
            console.log('AR/REG&SUB');
        }
        else {
            window.location.href = 'http://login.mondiamediamena.com/billinggw-lcm/billing?method=getcustomer&merchantId=243&redirect='+environment['link']+'en%2Fsubscribe-and-register&operatorId=' +this.mondiaOperatorID
        }
    }
    createandsub() {
        console.log('create and sub')
        this.http.get('https://staging.videyo.tv/manage/subscribeRegister?siteID='+this.siteID+'&mobileOperatorText=' + this.mondiaOperatorText + '&customerId=' + this.customerId + '&selfRenew=true', {
            })
            .subscribe(
                data => {
                    this.username = data['username'];
                    this.tempPass = data['tempPassword'];
                    this.subData = data['subscriptionStatus'];
                    this.subID = this.subData['id'];
                    this.userStatus = data['isNewUser'];
                    if(this.userStatus == true) {
                        this.newUserLogin();
                    }
                    else {
                        this.showPass = true;
                    }
                    console.log('SUB ID = ' + this.subID);

                  
                },
                
                error => {
this.failedSub = true;
this.userStatus = false;
console.log(error.status);
                }
            );

    }
    ngOnInit() {

        setTimeout(() => {
            /** spinner ends after 5 seconds */
            this.loaded = true;
        }, 1500);
    }
    newUserLogin() {
        this.route.params.subscribe(params2 => {
            this.redirectURL = params2['redirect'];
            var currentUser
            var baseUrl = "https://api-staging.videyo.tv"

            this.http.post(baseUrl + '/api/login', {
                'username': this.username,
                'password': this.tempPass
            }).subscribe(
                res => {
                    localStorage.setItem('access_token', (res["access_token"]));
                    this.router.navigate(['/subscribe-confirm/' + this.subID + '/reset']);


                },
                err => {
                }
            );
            return false;
        });
        console.log('New User Login')
    }
    loginUser() {
            var currentUser
            var baseUrl = "https://api-staging.videyo.tv"

            this.http.post(baseUrl + '/api/login', {
                'username': this.username,
                'password': this.tempPass
            }).subscribe(
                res => {
                    localStorage.setItem('access_token', (res["access_token"]));
                    this.router.navigate(['/subscribe-confirm/' + this.subID]);

                },
                err => {
                }
            );
            console.log('Normal Login')
            return false;
       
    }
    onUsernameUp(event: any) {
        this.usernameLogin = event.target.value;
        console.log(this.usernameLogin);
    }
    onPasswordUp(event: any) {
        this.tempPass = event.target.value;
        console.log(this.passLogin);
    }
    getDisclaimer() {
    if (window.location.pathname.indexOf('\/en\/') > -1) {
        this.http.get('https://staging.videyo.tv/manage/getProductDisclaimer?productBillingID='+this.productId+'&language=en',  {
    
        })
          .subscribe(
            data => {
                
             this.disclaimer = data;
             this.disclaimerHTML = this.disclaimer['htmlSource'];
             console.log('terms');
             console.log(this.disclaimer);
             this.disclaimerLoaded = true;
            },
            error => {
             
            }
          
          );
      }
      else if (window.location.pathname.indexOf('\/ar\/') > -1) {
        this.http.get('https://staging.videyo.tv/manage/getProductDisclaimer?productBillingID='+this.productId+'&language=ar',  {
    
        })
          .subscribe(
            data => {
             this.disclaimer = data;
             this.disclaimerHTML = this.disclaimer['htmlSource'];
             console.log('terms');
             console.log(this.disclaimer);
             this.disclaimerLoaded = true;
            },
            error => {
             
            }
          
          );
      }
      else if (window.location.pathname.indexOf('\/fr\/') > -1) {
        this.http.get('https://staging.videyo.tv/manage/getProductDisclaimer?productBillingID='+this.productId+'&language=fr',  {
    
        })
          .subscribe(
            data => {
             this.disclaimer = data;
             this.disclaimerHTML = this.disclaimer['htmlSource'];
             console.log('terms');
             console.log(this.disclaimer);
             this.disclaimerLoaded = true;
            },
            error => {
             
            }
          
          );
      }
else { 
        this.http.get('https://staging.videyo.tv/manage/getProductDisclaimer?productBillingID='+this.productId+'&language=en',  {
    
        })
          .subscribe(
            data => {
             this.disclaimer = data;
             this.disclaimerHTML = this.disclaimer['htmlSource'];
             console.log('terms');
             console.log(this.disclaimer);
             this.disclaimerLoaded = true;
            },
            error => {
             
            }
          
          );
      }
}
}
